import { render, staticRenderFns } from "./NewBehaviourForm.vue?vue&type=template&id=02056504&scoped=true&"
import script from "./NewBehaviourForm.vue?vue&type=script&lang=js&"
export * from "./NewBehaviourForm.vue?vue&type=script&lang=js&"
import style0 from "./NewBehaviourForm.vue?vue&type=style&index=0&id=02056504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02056504",
  null
  
)

export default component.exports